/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { userSettingControllerGetMe } from '../fn/user-setting/user-setting-controller-get-me';
import { UserSettingControllerGetMe$Params } from '../fn/user-setting/user-setting-controller-get-me';
import { userSettingControllerUpdate } from '../fn/user-setting/user-setting-controller-update';
import { UserSettingControllerUpdate$Params } from '../fn/user-setting/user-setting-controller-update';
import { UserSettingDto } from '../models/user-setting-dto';

@Injectable({ providedIn: 'root' })
export class UserSettingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userSettingControllerGetMe()` */
  static readonly UserSettingControllerGetMePath = '/api/user-setting';

  /**
   * 내 설정 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSettingControllerGetMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSettingControllerGetMe$Response(params?: UserSettingControllerGetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSettingDto>> {
    return userSettingControllerGetMe(this.http, this.rootUrl, params, context);
  }

  /**
   * 내 설정 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSettingControllerGetMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userSettingControllerGetMe(params?: UserSettingControllerGetMe$Params, context?: HttpContext): Observable<UserSettingDto> {
    return this.userSettingControllerGetMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserSettingDto>): UserSettingDto => r.body)
    );
  }

  /** Path part for operation `userSettingControllerUpdate()` */
  static readonly UserSettingControllerUpdatePath = '/api/user-setting';

  /**
   * 유저 설정 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userSettingControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSettingControllerUpdate$Response(params: UserSettingControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return userSettingControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 유저 설정 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userSettingControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userSettingControllerUpdate(params: UserSettingControllerUpdate$Params, context?: HttpContext): Observable<boolean> {
    return this.userSettingControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
